import { atom } from "recoil";
import { persistAtomEffect } from "../effects/persistAtom";

export const checkedUsersMembersState = atom<Array<Guid>>({
  key: 'CheckedUsersMembersState',
  default: [],
});
